<template>
  <div>
    <my-asidebar v-bind:active-tab="'reports'"> </my-asidebar>
    <section class="dashboard-area p-3">
      <top-bar></top-bar>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-box">
              <div class="form-title-wrap">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="title">Sail Booking Report</h3>
                </div>
              </div>

              <v-app>
                <v-data-table
                    :headers="headers"
                    :items="forecastData"
                    :items-per-page="100"
                    class="elevation-1"
                    :search="search"
                    :custom-filter="filter"
                >
                  <!--                  show-group-by-->
                  <template v-slot:item.sailDate="{ item }">
                    <tr>
                      {{ item.sailDate | ddMMyyyy }}
                    </tr>
                  </template>
<!--                  <template v-slot:item.bookingNumber="{ item }">-->
<!--                    <tr>-->
<!--                      {{ item.bookingNumber }}-->
<!--                    </tr>-->
<!--                  </template>-->
<!--                  <template v-slot:item.totalEndorsement="{ item }">-->
<!--                    <tr>-->
<!--                      {{ item.totalEndorsement | toCurrency }}-->
<!--                    </tr>-->
<!--                  </template>-->
<!--                  <template v-slot:item.averageAge="{ item }">-->
<!--                    <tr>-->
<!--                      {{ item.averageAge.toFixed(2)}}-->
<!--                    </tr>-->
<!--                  </template>-->
<!--                  <template v-slot:item.sailDate="{ item }">-->
<!--                    <tr>-->
<!--                      {{ item.sailDate | ddMMyyyy}}-->
<!--                    </tr>-->
<!--                  </template>-->
                </v-data-table>
              </v-app>
            </div>
          </div>
        </div>
<!--        <div class="row">-->
<!--          <div class="col-lg-12 ml-2">-->
<!--            <div class="row">-->
<!--              <base-edit-input-->
<!--                  v-model="email"-->
<!--                  :rules="'required'"-->
<!--                  :type="'text'"-->
<!--                  :label="'Email'">-->
<!--              </base-edit-input>-->
<!--              <div class="input-box" style="margin-left: 10px">-->
<!--                <label>-</label>-->
<!--                <div class="form-group">-->
<!--                  <button class="theme-btn" type="button" @click="onSendEmail()">Gönder</button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
    </section>
<!--            </div>-->
</div>
<!--  </div>-->
</template>

<script>
import ReservationStatus from "../component/common/ReservationStatus";
import BaseEditInput from "../component/base/BaseEditInput";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
// import generalFunctions from "../util/generalFunctions";

export default {
  name: "ForeCastReport",
  components: {TopBar, MyAsidebar, BaseEditInput, ReservationStatus},
  data () {
    return {
      forecastData: [],
      sending : false,
      email: null,
      search: '',
      headers: [
        {
          align: 'start',
          text: 'Sefer Id',
          sortable: true,
          value: 'sailId',
        },
        {
          text: 'Sefer Tarihi',
          sortable: true,
          value: 'sailDate'
        },
        {
          text: 'Boş Oda',
          sortable: true,
          value: 'freeRoom'
        },
        {
          text: 'Oda (Gece)',
          sortable: true,
          value: 'roomNight'
        },
        {
          text: 'pax (Yetişkin)',
          sortable: true,
          value: 'pax'
        },
        {
          text: 'Cocuk (Ücretli)',
          sortable: true,
          value: 'childPaid'
        },
        {
          text: 'Cocuk (Bedava)',
          sortable: true,
          value: 'childFree'
        },
        {
          text: 'Toplam Pax',
          sortable: true,
          value: 'totalPax'
        },
        {
          text: 'Oda %',
          sortable: true,
          value: 'roomPercentage'
        },
        {
          text: 'roomRevenueCurrency',
          sortable: true,
          value: 'roomRevenueCurrency'
        },
        {
          text: 'roomRevenueLocalCurrency',
          sortable: true,
          value: 'roomRevenueLocalCurrency'
        },
        {
          text: 'paxCurrency',
          sortable: true,
          value: 'paxCurrency'
        },
        {
          text: 'paxLocalCurrency',
          sortable: true,
          value: 'paxLocalCurrency'
        },
        // {
        //   text: 'extraPaxCurrency',
        //   sortable: true,
        //   value: 'extraPaxCurrency'
        // },
        {
          text: 'roomAverageCurrency',
          sortable: true,
          value: 'roomAverageCurrency'
        },
        {
          text: 'roomAverageLocalCurrency',
          sortable: true,
          value: 'roomAverageLocalCurrency'
        }
      ]
    }
  },
  computed:{
    sailBookingReportData:{
      get(){
        let sailBookingReportData = this.$store.getters.getSailReportData;
        if(!sailBookingReportData) return null;

        sailBookingReportData.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.sailDate) - new Date(a.sailDate);
        });

        return sailBookingReportData;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  methods:{
    filter (value, search, item) {
      if(value == null || search == null){
        return false;
      }

      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_FORECAST_REPORT"]) this.$router.push("/");

    this.$store.dispatch("loadForeCastReportData").then(response =>{
      this.forecastData = response;
    });
  }
}
</script>

<style scoped>

</style>